import { useAuth0 } from '@auth0/auth0-react';
export default useAuth0;
